var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content md",staticStyle:{"position":"relative"}},[_c('buddhism-calendar',{attrs:{"show-out-month":""}}),(_vm.admin)?_c('a-button',{staticClass:"export-buddhism",attrs:{"type":"primary","loading":_vm.exporting},on:{"click":_vm.exportData}},[_vm._v(_vm._s(_vm.exporting ? '正在导出' : '本月佛事预订导出'))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }